import { ReactElement } from 'react'
import { Box, Typography } from '@mui/material'
import Results2CommentField from '../Results2CommentField'

interface Props {
  value?: string
  onChange?: (value: string) => void
}

const Results2CommentSection = ({ value, onChange }: Props): ReactElement => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
    <Typography
      sx={{
        fontSize: 12,
        fontWeight: 600,
        color: 'text.primary',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
      }}
    >
      Kommentare
    </Typography>
    <Results2CommentField value={value} onChange={onChange} />
  </Box>
)

export default Results2CommentSection
